import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col-xl-6 ant-col-xs-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_5 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_6 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_7 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_8 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_9 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_10 = { class: "ant-col-xl-18 ant-col-xs-24" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_unidade = _resolveComponent("selecionar-unidade")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form_item, {
            label: "UN Principal",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_unidade, {
                "codigo-selecionado": _ctx.props.codigoUnidadePrincipal,
                siglaSelecionada: _ctx.state.unidadeSelecionada.siglaUnidadePrincipal,
                "onUpdate:siglaSelecionada": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.unidadeSelecionada.siglaUnidadePrincipal) = $event)),
                empresas: _ctx.props.empresas,
                disabled: true
              }, null, 8, ["codigo-selecionado", "siglaSelecionada", "empresas"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form_item, {
            label: 'Qtd em ' + _ctx.state.unidadeSelecionada.siglaUnidadePrincipal,
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.state.unidadeSelecionada.equivalenciaPrincipal,
                "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.unidadeSelecionada.equivalenciaPrincipal) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_form_item, {
            label: "UN Conversão",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_unidade, {
                "codigo-selecionado": _ctx.state.unidadeSelecionada.codigoUnidade,
                "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.unidadeSelecionada.codigoUnidade) = $event)),
                siglaSelecionada: _ctx.state.unidadeSelecionada.siglaUnidade,
                "onUpdate:siglaSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.unidadeSelecionada.siglaUnidade) = $event)),
                empresas: _ctx.props.empresas
              }, null, 8, ["codigo-selecionado", "siglaSelecionada", "empresas"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_form_item, {
            label: _ctx.UtilitarioGeral.valorValido(_ctx.state.unidadeSelecionada.siglaUnidade) ? 'Qtd equivalente em ' + _ctx.state.unidadeSelecionada.siglaUnidade : 'Qd equivalente',
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.state.unidadeSelecionada.equivalenciaSecundaria,
                "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.unidadeSelecionada.equivalenciaSecundaria) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_form_item, {
            label: "% Formação Preço",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.state.unidadeSelecionada.percentualFormacaoPreco,
                "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.unidadeSelecionada.percentualFormacaoPreco) = $event)),
                percentual: true
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_form_item, {
            label: " ",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "ant-btn ant-btn-secondary",
                style: {"width":"100%"},
                onClick: _ctx.adicionarUnidade
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Adicionar")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_table, {
          class: _normalizeClass(_ctx.computedUnidades.length > 0 ? 'ss-grade ss-tamanho-grade-modal' : 'ss-grade ss-tamanho-grade'),
          columns: _ctx.state.colunas.filter(item => item.visible),
          "data-source": _ctx.computedUnidades,
          rowKey: "codigo",
          pagination: false,
          loading: _ctx.telaBase.carregando,
          scroll: { y: _ctx.state.windowHeight },
          size: "small"
        }, {
          bodyCell: _withCtx(({ column, record, text, index }) => [
            (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais)), 1))
              : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.removerUnidade(index))
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(text), 1))
          ]),
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, {
              resultadoPesquisa: !_ctx.telaBase.carregando,
              mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhuma unidade lançada...'
            }, null, 8, ["resultadoPesquisa", "mensagem"])
          ]),
          _: 1
        }, 8, ["class", "columns", "data-source", "loading", "scroll"])
      ])
    ])
  ]))
}